// extracted by mini-css-extract-plugin
export default {"container":"ImportantNumber_container__58Epg","number":"ImportantNumber_number__nuzoJ","text":"ImportantNumber_text__Kytn7"};